var map = {
	"./About_ys_big_1.jpg": "e54c",
	"./About_ys_big_2.jpg": "435c",
	"./About_ys_big_3.jpg": "becc",
	"./About_ys_big_4.jpg": "6143",
	"./About_ys_big_5.jpg": "3ec6",
	"./About_ys_big_6.jpg": "f04f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ea22";